import { commentsData } from '@/mocks/home';

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">吃瓜群众说</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">来自广大吃瓜群众的真实声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.nickname}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.nickname}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}